export default function CustomAction() {
  return <h3>This is CustomAction Page</h3>;
}
